'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const TagRoot = styled__default["default"].div.withConfig({
  componentId: "sc-1emuca2-0"
})(["position:relative;width:100%;"]);
const TagContent = styled__default["default"].span.withConfig({
  componentId: "sc-1emuca2-1"
})(_ref => {
  let {
    s,
    anchor
  } = _ref;
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    left: anchor.horizontal === 'left' ? '0' : undefined,
    right: anchor.horizontal === 'right' ? '0' : undefined,
    top: anchor.vertical === 'top' ? '0' : undefined,
    bottom: anchor.vertical === 'bottom' ? '0' : undefined,
    backgroundColor: '#000000',
    color: '#ffffff',
    padding: '0.25rem 0.5rem',
    fontSize: '0.75rem',
    borderRadius: '0.25rem 0rem',
    ...s
  };
});
const Tag = _ref2 => {
  let {
    children,
    tagContent,
    anchor = {
      horizontal: 'left',
      vertical: 'top'
    },
    s
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(TagRoot, null, children, tagContent && /*#__PURE__*/React__default["default"].createElement(TagContent, {
    s: s,
    anchor: anchor
  }, tagContent));
};

exports.TagContent = TagContent;
exports.TagRoot = TagRoot;
exports["default"] = Tag;
